module.exports = __webpack_public_path__ + "img/feetback.958e35ca.png";